/**
 * Route for `agency-features`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyFeaturesPage } from "../features/agency-features/AgencyFeaturesPage";

export const agencyFeaturesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency-features",
	component: AgencyFeaturesPage,
});

export default agencyFeaturesRoute;
